export const routes = (parentName) => {
  return [
    {
      path: "games",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Games`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Games-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Games-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Games-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
